import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BaseButtonStyle } from 'styles/components';
import { ColorScheme, Fonts } from 'styles/constants';
export {
  ActivityIndicator,
  Button,
  FormActions,
  FormRow,
} from 'styles/components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ReCaptchaContainer = styled.div`
  transform: scale(0.96) translateX(-6px);
  margin-top: 20px;
  margin-bottom: 16px;
`;

export const ForgotMyPwsLink = styled(Link)`
  ${BaseButtonStyle};
  margin-left: auto;
  font-family: ${Fonts.GilroySemiBold};
  color: ${ColorScheme.LightText};
  font-size: 14px;
`;

export const LockoutMessage = styled.p`
  margin: 0 0 12px;
  font-family: ${Fonts.GilroySemiBold};
  font-size: 14px;
  color: ${ColorScheme.Danger};
`;
